import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface InvoiceCompletedStore {
  invoiceCompleted: boolean;
  setInvoiceCompleted: ( completed: boolean ) => void;
}

export const useInvoiceCompletedStore = create<InvoiceCompletedStore>()(
  persist(
    ( set ) => ({
      invoiceCompleted: false,
      setInvoiceCompleted: ( completed ) => set({ invoiceCompleted: completed })
    }),
    {
      name: `invoice-completed`,
      storage: createJSONStorage( () => sessionStorage )
    }
  )
)
